export default {
  props: {
    value: {
      type: [Number, Array]
    },
    currentDate: {
      type: Number,
      required: true
    },
    range: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    choosing: {
      type: Boolean,
      default: false
    },
    chooseStartValue: {
      type: Number
    }
  }
};
